import { Text } from "@src/components/deprecated/Text/Text";
import { GeoPoint } from "firebase/firestore";
import { t } from "i18next";
import { DataObjectFieldComparator } from "../../DataObjects/DataObjectFieldComparator";
import { DataObjectType } from "../../DataObjects/DataObjectHelper";
import { DataObjectField, InputElementContext } from "../DataObjectField";

export class FirebaseDataLocationField<FirebaseDataType extends DataObjectType> extends DataObjectField<GeoPoint, FirebaseDataType> {
  equalComparator = (a: GeoPoint | undefined, b: GeoPoint | undefined) => {
    return a?.latitude === b?.latitude && a?.longitude === b?.longitude;
  };
  override singleInputElement = (value: GeoPoint | undefined, setValue: (value: GeoPoint | undefined) => void, context?: InputElementContext) => {
    return <Text size="sm" text={t("main.notYetSupported")} />;
  };
  getReadableStringRepresentation(value: GeoPoint): string {
    return value.latitude + ", " + value.longitude;
  }
  encodeString = (value: GeoPoint) => {
    return value.latitude + "," + value.longitude;
  };
  decodeString = (value: string) => {
    const parts = value.split(",");
    if (parts.length === 2) {
      const latitude = parseFloat(parts[0]);
      const longitude = parseFloat(parts[1]);
      if (!isNaN(latitude) && !isNaN(longitude)) {
        return new GeoPoint(latitude, longitude);
      }
    }
    return undefined;
  };
  encode = (value: GeoPoint) => value;
  decode = (value: any) => {
    if (value instanceof GeoPoint) return value;
    if (typeof value === "string") return this.decodeString(value);
    else if (typeof value === "object" && typeof value.latitude === "number" && typeof value.longitude === "number")
      return new GeoPoint(value.latitude, value.longitude);
    return undefined;
  };
  allComparators: DataObjectFieldComparator[] = ["equals", "not-equals", "is-known", "is-unknown"];

  override isValueValid = (value: any): boolean => {
    return value instanceof GeoPoint;
  };
}

